import { css } from 'emotion';

import { fonts } from '@cobliteam/base-components';

const favoriteButton = (isTableButton: boolean) => css`
  overflow: hidden;
  opacity: ${isTableButton ? 0 : 1};

  & span {
    margin-left: 0;
  }
  transition: opacity 0.4s ease-in-out;
  font-size: ${fonts.size.medium};
`;

const favoriteButtonWrapper = css`
  transition: background-color 0.4s ease-in-out;
  &:hover {
    background-color: #0234E11a;
  }
`;

export { favoriteButton, favoriteButtonWrapper };
